import React, { useEffect } from 'react';
import { SEO } from '../components/SEO';

const Member: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO 
        title="Member Expectations | Monday Night Group"
        description="Expectations and guidelines for Monday Night Group members."
      />

      {/* Hero Section */}
      <section 
        className="relative h-[50vh] bg-gradient-to-r from-blue-900 to-blue-700 flex items-center"
        style={{ 
          backgroundImage: 'url(/image copy 2.png)', 
          backgroundSize: 'cover',
          backgroundPosition: 'top'
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>
        <div className="container mx-auto px-4 z-10">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-bold text-white leading-tight mb-4">
              Member Expectations
            </h1>
            <p className="text-xl text-white">
              What we hope for from our community members
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            {/* Member Expectations */}
            <div className="mb-16">
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Meeting Expectations</h2>
              <div className="bg-blue-50 p-8 rounded-lg">
                <div className="space-y-6 text-gray-700">
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center font-semibold mr-4 flex-shrink-0 mt-1">
                      1
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-gray-800 mb-2">Come Prepared</h3>
                      <p>We are hopeful that you have come prepared; that means having read the reading for that week</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center font-semibold mr-4 flex-shrink-0 mt-1">
                      2
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-gray-800 mb-2">Consistent Attendance</h3>
                      <p>Are consistent in attendance, and are there for the majority of meetings</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center font-semibold mr-4 flex-shrink-0 mt-1">
                      3
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-gray-800 mb-2">Engage & Be Open</h3>
                      <p>Ready to engage in discussion and be open to the refining from the scriptures</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Additional Information */}
            <div className="grid gap-6">
              <div className="border-l-4 border-blue-600 pl-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">Heart of Community</h3>
                <p className="text-gray-600">Our gatherings are most meaningful when everyone comes ready to participate, learn, and grow together. Your preparation and engagement help create an environment where iron sharpens iron.</p>
              </div>

              <div className="border-l-4 border-blue-600 pl-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">Grace and Growth</h3>
                <p className="text-gray-600">We understand that life happens and perfect attendance isn't always possible. What matters most is your heart to grow in Christ and commitment to the community when you're able to be present.</p>
              </div>

              <div className="border-l-4 border-blue-600 pl-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">Mutual Encouragement</h3>
                <p className="text-gray-600">We're all on this journey together. Come ready to both give and receive encouragement, knowing that God uses each of us to speak truth and life into one another's lives.</p>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default Member;